import ListNameCell from './ListNameCell';

export default ListNameCell;
